import React, { Component } from 'react';
import {
  
} from "react-router-dom";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from '../../constant/Utils';
import Header from '../common/Header';
import Footer from '../common/Footer';

import { postTerms, CMS_BASE_URL } from '../../redux/action';

import './home.css'; 
import '../common/common.css'; 

import accountBanner from '../../images/generalBanner.png';

class Terms extends Component {

	constructor(props, context) {
	    super(props, context);
	    this.state = {
	    	title: "Terms",
	    	terms: {}
	    };
    }

	
	componentWillMount() {
		
		let token = window.localStorage.getItem("token");
		if (!token) {
			window.location.href = "/login";
		}

	}


	componentDidMount() {

		
		
		postTerms({}).then(res => {
				this.setState({ 
					terms: res.data.terms
				})
			}, this)
	}



	render() {

		return(
			<div className="geContainer">
				<Header urlKey={this.props.urlKey} />
				<div className="mainContainer">
					<img className="banner" src={accountBanner} />
					
					
						<div className="sectionContainer">
							<div class="sectionContainer">
								<div class="headline containerMaxWidth">
									<h2>PRIVACY NOTICE</h2>
								</div>
								<div class="bodyContent containerMaxWidth">
									<div class="text">
									<p>Please refer to the terms of <a href="https://www.azprivacy.astrazeneca.com/asia-pacific/hongkong/en/privacy-notices.html#accordion-list-item-75b4bb02e1" target="_blank" rel="noopener">Astrazeneca's privacy policy</a> and <a target="_blank" href="https://www.daiichisankyo.com.hk/Privacy/">Daiichisankyo's privacy policy</a>.&nbsp;</p>
									
									</div>
								</div>
							</div>
						</div>

					
				</div>
				<Footer urlKey={this.props.urlKey} />
			</div>
		);
	}

}

const mapStateToProps = (state) => {
  return {

  };
}

const mapDispatchToProps = dispatch => bindActionCreators({

}, dispatch)

export default withRouter(connect(
  mapStateToProps,
  {  }
)(Terms));